import { App } from "vue";
import LeftMenu from "./src/index.vue"
export default {
    install(app:App){
        app.component('LeftMenu',LeftMenu)
    }
}